import React, { Component, Fragment } from 'react';
import { Route, Redirect } from 'react-router-dom';
import CelaneseAPI from './services';
import config from './config';
import { connect } from 'react-redux';
import { userProfileData, userRoleInfo, loggedState, getLoggedUser, isProfileLoaded, towItemsData, getLocaleTranslationData } from './actions';
import PropTypes from 'prop-types';

class AuthorizedRoute extends Component {
	constructor(props) {
        super(props);
        this.state = {
            errorHandler: ''
        };
    }
	componentWillMount() {
		if (typeof NodeList.prototype.forEach === "undefined") {
			NodeList.prototype.forEach = Array.prototype.forEach;
		}
		if (typeof HTMLCollection.prototype.forEach === "undefined") {
			HTMLCollection.prototype.forEach = Array.prototype.forEach;
		}
		CelaneseAPI.get(config.API.getMyPreferences).then((resp) => {
			let response = resp.data;
            if(response) {
				let profileData = response.profile ? response.profile.azureProfile : '';
				let userRole = profileData ? profileData.role : '';
				if(userRole) {
					this.props.userRoleInfo(userRole);
					if (response.profile && response.profile.isFirstLoad && profileData.azureId && (userRole.toUpperCase() === 'CE-USER' || userRole.toUpperCase() === 'ADMIN')) {
						CelaneseAPI.post(config.API.setAzureGroup, {
							groupId: process.env.REACT_APP_AZURE_GROUP_ID || '0634ea10-8059-40b5-a7cd-10838694a81b',
							memberId: profileData.azureId
						});
					}
				}

				this.props.userProfileData(response);
				const langCode = response.preferences.language || 'en';
				getLocaleTranslationData(langCode);
				CelaneseAPI.get(config.API.myTowItems).then((resp) => {
					if(resp.data) {
						this.props.towItemsData(resp.data);
					} else if(resp.error) {
						this.props.towItemsData(resp);
					}
					this.props.isProfileLoaded(true);
					const loginToken = localStorage.getItem('token') || '';
					if(loginToken) {
						this.props.loggedState(true);
						this.props.getLoggedUser(loginToken);
					} else {
						this.props.loggedState(false);
					}
				});
            } else if(resp.error) {
				localStorage.removeItem('token');
                localStorage.removeItem('sessiontoken');
				this.props.loggedState(false);
				this.props.isProfileLoaded(true);
			}
        }).catch(() => {
			localStorage.removeItem('token');
            localStorage.removeItem('sessiontoken');
			this.props.loggedState(false);
			this.props.isProfileLoaded(true);
		});
	}

	render() {
		const { component: Component, pending, logged, ...rest } = this.props;
		let self = this;
		return (
			<Route {...rest} render={props => {
				if (pending || !self.props.profileLoaded) {
					return <div className="loading-indicator">
						<h2 className="loading-indicator-text">
							{/* <Icon type="loading" theme="outlined" /> */}
							<img alt='loading celanese' src="./images/Celanese_loading.svg" />
						<span>Loading</span></h2>
					</div>
				} else {
					return (<Fragment>
						{ self.props.profileLoaded ? (
								logged ? <Component {...props} /> : <Redirect to="/login" />
							) : null
						}
					</Fragment>)
				}
			}} />
		)
	}
}

const stateToProps = ({ loggedUserState }) => ({
	pending: loggedUserState.pending,
	logged: loggedUserState.logged,
	profileLoaded: loggedUserState.profileLoaded
});

const dispatchToProps = dispatch => ({
	getLoggedUser: (data) => dispatch(getLoggedUser(data)),
	loggedState: (data) => dispatch(loggedState(data)),
	userProfileData: (data) => dispatch(userProfileData(data)),
	userRoleInfo: (data) => dispatch(userRoleInfo(data)),
	isProfileLoaded: (data) => dispatch(isProfileLoaded(data)),
	towItemsData: (data) => dispatch(towItemsData(data))
});

export default connect(stateToProps,dispatchToProps)(AuthorizedRoute);

AuthorizedRoute.propTypes = {
	component: PropTypes.any,
	pending: PropTypes.bool,
	logged: PropTypes.bool,
	isProfileLoaded: PropTypes.func,
	getLoggedUser: PropTypes.func,
	loggedState: PropTypes.func,
	userProfileData: PropTypes.func,
	userRoleInfo: PropTypes.func,
	profileLoaded: PropTypes.bool,
	towItemsData: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/AuthorizedRoute.js